import React from 'react'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { userForgotPassword } from '../../redux/actions/auth/forgotPasswordAction'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Box, Grid, Stack } from '@mui/material'
import { FormProvider } from '../../common/hook-form'
import 'react-toastify/dist/ReactToastify.css'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { Email, Password } from '@mui/icons-material'
import { useSnackbar } from 'notistack'
import {
  DividerText,
  ForgotPasswordButton,
  HeaderContainer,
  IconContainer,
  StyledDivider,
  StyledIcon,
  StyledLoadingButton,
  StyledTextField,
  SubTitle,
  WelcomeTitle,
} from './StyledElements'

export default function ForgotPassword() {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [isLoading, setLoading] = React.useState(false)

  const searchParams = new URLSearchParams(useLocation().search)
  const username = searchParams.get('username') || ''

  // redirect authenticated user to profile screen
  // useEffect(() => {
  //   if (Object.keys(fpInfo).length !== 0) {
  //     // navigate('/reset-password')
  //   } else if (error) {
  //     console.log('error', error)
  //     enqueueSnackbar(error || 'Something went wrong', { variant: 'error' })
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [navigate, fpInfo, error])

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      const result = await dispatch(userForgotPassword(data)).unwrap()
      if (result.data.status === 'success') {
        navigate('/otp?type=forgot-password', { state: { email: data.username, mfaTokenId: result.data?.tokenId } })
      }
    } catch (err) {
      console.log('err', err)
      enqueueSnackbar(err || 'Something went wrong', { variant: 'error' })
    } finally {
      setLoading(false)
    }
  }

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        username: Yup.string().required('Please enter a valid email address'),
      })
    ),
    defaultValues: {
      username: username,
    },
  })

  const { handleSubmit } = methods

  return (
    <>
      <Box>
        <HeaderContainer>
          <WelcomeTitle variant='h4'>Forgot Password</WelcomeTitle>
          <SubTitle variant='body1' color='text.secondary'>
            Please provide your details below to reset your password
          </SubTitle>
        </HeaderContainer>

        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <StyledTextField
                name='username'
                label='Email Address'
                variant='outlined'
                placeholder='Please enter your registered email address'
                fullWidth
                InputProps={{
                  startAdornment: (
                    <IconContainer>
                      <StyledIcon>
                        <Email />
                      </StyledIcon>
                    </IconContainer>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack spacing={2}>
                <StyledLoadingButton
                  loading={isLoading}
                  type='submit'
                  startIcon={<Password />}
                  variant='contained'
                  fullWidth
                  size='large'
                >
                  Send OTP
                </StyledLoadingButton>
                <StyledDivider>
                  <DividerText variant='body2' color='text.secondary'>
                    OR
                  </DividerText>
                </StyledDivider>
                <ForgotPasswordButton variant='text' component={Link} to='/login'>
                  Back to Login
                </ForgotPasswordButton>
              </Stack>
            </Grid>
          </Grid>
        </FormProvider>
      </Box>
    </>
  )
}
